export enum LAYOUT_MODES {
  LIGHT = "light",
  DARK = "dark",
}

export enum CHATS_TABS {
  ARCHIVE = "acrhive",
  DEFAULT = "default",
}

export enum TABS {
  USERS = "pills-user",
  CHAT = "pills-chat",
  CHAT_SUP = "pills-chatsup",
  CONTACTS = "pills-contacts",
  CALLS = "pills-calls",
  BOOKMARK = "pills-bookmark",
  SETTINGS = "pills-setting",


  TEST = "pills-test",
  WORKPLACE = "pills-workplace",
  TASK = "pills-task",
  APPROVAL = "pills-approval",
}

export enum WpModes {
  Workplace = 1,
  Task = 2
}

export enum WpSortMode {
  Latest = 1,
  DueDate = 2,
  ResponderName = 3
}